import { render, staticRenderFns } from "./LongitudinalChart.vue?vue&type=template&id=2df25cbc&scoped=true"
import script from "./LongitudinalChart.vue?vue&type=script&lang=js"
export * from "./LongitudinalChart.vue?vue&type=script&lang=js"
import style0 from "./LongitudinalChart.vue?vue&type=style&index=0&id=2df25cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df25cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
